module.exports = __webpack_public_path__ + "img/bell-loader-anim.441d5b82.gif";